var map = {
	"./KoalaBotLogo-min.png": 4091,
	"./LogoText-min.png": 8441,
	"./NUEL-min.png": 4487,
	"./NUEL2-min.png": 5146,
	"./NUEL3-min.png": 5529,
	"./SVGE_LOGO-min.png": 5779,
	"./Swansea-min.png": 3209,
	"./UWE-min.png": 4274,
	"./developer_photos/Anan-min.png": 9514,
	"./developer_photos/Jack-min.png": 1293,
	"./developer_photos/Kieran-min.png": 7047,
	"./developer_photos/Robert-min.png": 7241,
	"./developer_photos/Stefan-min.png": 4769,
	"./developer_photos/aqeel-min.png": 5646,
	"./developer_photos/bill-min.png": 757,
	"./developer_photos/default-min.png": 2164,
	"./developer_photos/harry-min.png": 6367,
	"./developer_photos/jack_2-min.png": 9249,
	"./developer_photos/jack_3-min.png": 2495,
	"./developer_photos/joe-min.png": 4742,
	"./developer_photos/john-min.png": 1660,
	"./developer_photos/otto-min.png": 1190,
	"./developer_photos/pom-min.png": 754,
	"./developer_photos/viraj-min.png": 2529,
	"./example_graph.png": 8943
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;